import { render, staticRenderFns } from "./DemandePermisPsychologueRegulier.vue?vue&type=template&id=38a54e03"
import script from "./DemandePermisPsychologueRegulier.vue?vue&type=script&lang=js"
export * from "./DemandePermisPsychologueRegulier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports